import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { MileStoneApi } from "../../shared/api/MileStoneApi";
import { DataItemArray, ProjectDetails } from "../../models/Milestone";
import { RootState } from "../store";

export interface MilestoneState {
   milestones: DataItemArray | null;
   projectMilestones: ProjectDetails[];
   loading: boolean,
   error: string | null;
   projectId: number | null;
   milestoneId: number | null; 
};

const initialState: MilestoneState = {
    milestones: null,
    projectMilestones: [],
    loading: false,
    error: null,
    projectId: null,
    milestoneId: null
};

export const mileStoneSlice = createSlice({
    name:"milestone",
    initialState,
    reducers: {
        setProjectId: (state, action) => {
            state.projectId = action.payload;
            localStorage.setItem('projectId', action.payload); 
        },
        setMilestoneId: (state, action) => {
            state.milestoneId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            isAnyOf(
               MileStoneApi.endpoints.getMilestoneData.matchFulfilled,
            ),
            (state, action) => {
                state.loading = false;
                state.milestones = action.payload;
                state.error = null;
            }
        );

        builder.addMatcher(
            isAnyOf(MileStoneApi.endpoints.getMilestoneData.matchPending),
            (state) => {
                state.loading = true;
                state.error = null;
            }
        );

        builder.addMatcher(
            isAnyOf(
                MileStoneApi.endpoints.getMilestoneData.matchRejected
            ),
            (state, action) => {
                state.loading = false;
                state.error = action.error?.message || "Failed to load milestone data";
            }
        );

        builder.addMatcher(
            isAnyOf(
                MileStoneApi.endpoints.getProjectMilestoneData.matchFulfilled,
            ),
            (state, action) => {
                state.loading = false;
                state.projectMilestones = action.payload.projectMilestone
            }
        );
    }
});
export const selectProjectId = (state: any) => {
    return state.milestone?.projectId;
};
export const selectMilestoneId = (state: any) => {
    return state.milestone?.milestoneId;
};

export const { setMilestoneId } = mileStoneSlice.actions;
export const { setProjectId } = mileStoneSlice.actions;
export const selectMilestones = (state: any) => state.milestone.milestones;
export const selectProjectMilestones = (state: RootState) =>  state.milestone.projectMilestones
export const selectMilestoneLoading = (state: any) => state.milestone.loading;
export const selectMilestoneError = (state: any) => state.milestone.error;
export default mileStoneSlice;

